import { Image } from 'antd-mobile'
import { useLocalStore, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

import HPopup from '@/components/NewEditForm/UILibrary/HYBVant/HPopup'
import flowStore from '@/pages/Flow/Store'

import HBlockAdd from '../../HYBVant/HBlockAdd'

import ReshuffleFrom from './ReshuffleFrom'

import './index.less'

const Reshuffle: React.FC<any> = ({ onConfirm, value, ...elementProps }) => {
  const fstore = useLocalStore(() => flowStore)
  const { changeReshuffle, changeReshuffleStatus } = fstore
  const [visible, setVisible] = useState(false)
  const add = () => {
    if (elementProps?.disabled) return
    changeReshuffleStatus('Add')
    setVisible(true)
  }

  const edit = (index: number) => {
    fstore.reshuffle.map((x: any, i: number) => {
      if (index === i) {
        x.active = 1
      } else x.active = 0
      return x
    })
    changeReshuffleStatus('Edit')
    setVisible(true)
  }

  useEffect(() => {
    if (onConfirm && fstore.reshuffle?.length) {
      onConfirm(fstore.reshuffle)
    }
  }, [fstore.reshuffle])

  useEffect(() => {
    changeReshuffle(value || [])
  }, [value])
  useEffect(() => {
    return () => {
      changeReshuffle([])
    }
  }, [])
  const onClose = () => {
    setVisible(false)
  }

  const renderSalaryDetails = (data: any) => {
    if (data?.salary_details?.length > 0) {
      return (
        <>
          【
          {data?.salary_details
            ?.map((detailItem: any) => `${detailItem?.name || ''}：${detailItem?.value || '-'}`)
            ?.join('、')}
          】
        </>
      )
    }
    return '-'
  }

  const _bool: boolean = !elementProps?.disabled && !elementProps?.readed
  const disabled = elementProps?.disabled
  const { isAgent = false } = elementProps
  // 已选择的异动项目
  const selectedMovementFieldList = fstore.reshuffle?.map((item: any) => item.movement_field)

  return (
    <>
      <div className={`reshuffle reshuffle-wrap${disabled ? '-disabled' : ''}`}>
        {fstore.reshuffle.map((x: any, index: number) => {
          const isPayStructure = x.movement_field === 'PAY_STRUCTURE'
          const changedValueName = isPayStructure
            ? x?.changed_salary_value?.salary_structure_template_name
            : x.changed_value_name
          const originalValueName = isPayStructure
            ? x?.original_salary_value?.salary_structure_template_name
            : x.original_value_name
          return (
            <div key={index} className='reshuffle-content'>
              {isAgent && !disabled && (
                <div className={`reshuffle-content-top-title`}>{x.movement_field_name || '-'}</div>
              )}
              <div className='reshuffle-content-top'>
                <div className={`reshuffle-content-top-left`}>
                  变更为：{changedValueName || '-'}{' '}
                  {isPayStructure ? renderSalaryDetails(x?.changed_salary_value) : null}
                </div>
                {!disabled && (
                  <div className='reshuffle-content-top-right'>
                    {_bool && (
                      <Image
                        onClick={() => edit(index)}
                        className='reshuffle-content-col-2-img'
                        src='https://s.huiyunban.cn/1747191709529280512.png'
                      />
                    )}
                  </div>
                )}
              </div>
              {(!isAgent || disabled) && (
                <div className='reshuffle-content-bottom'>
                  {x.movement_field_name}： {originalValueName || '-'}
                  {isPayStructure ? renderSalaryDetails(x?.original_salary_value) : null}
                </div>
              )}
            </div>
          )
        })}
        {!elementProps?.disabled && <HBlockAdd text='添加异动项' onClick={() => _bool && add()} />}
      </div>
      <HPopup
        title='选择异动项'
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          minHeight: '50vh'
        }}
        visible={visible}
        onCancel={onClose}
        hasOk={false}
      >
        {visible && (
          <ReshuffleFrom
            userId={elementProps?.userId || ''}
            is_show={elementProps?.is_show || ''}
            selectedMovementFieldList={selectedMovementFieldList}
            onClose={onClose}
            optionFilter={elementProps?.optionFilter}
            // onOk={onOk}
          />
        )}
      </HPopup>
    </>
  )
}

export default observer(Reshuffle)
